const STEPS = [
  { id: 1, label: 'Chi sei' },
  { id: 2, label: 'Prodotti' },
  { id: 3, label: 'Documenti' },
  { id: 4, label: 'Invio' },
];

export default function CandidaturaStepper({ step, progress = 0, isLogistica = false }) {
  const labels = isLogistica
    ? [
        { id: 1, label: 'Chi sei' },
        { id: 2, label: 'Servizi' },
        { id: 3, label: 'Documenti' },
        { id: 4, label: 'Invio' },
      ]
    : STEPS;

  return (
    <div className="w-full max-w-3xl px-4 sm:px-6" data-tour="candidatura-stepper">
      <div className="mb-2 flex justify-between text-xs text-gray-500">
        <span>Step {step} di {labels.length}</span>
        <span>{progress}% completato</span>
      </div>
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-gradient-to-r from-[#F6CF48] to-[#c78244] transition-all duration-500"
          style={{ width: `${Math.max(progress, (step / labels.length) * 100)}%` }}
        />
      </div>
      <div className="flex items-center gap-0">
        {labels.map((s, idx) => (
          <div key={s.id} className="flex items-center flex-1 min-w-0">
            <div className="flex flex-col items-center flex-1 min-w-0">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${
                  step > s.id
                    ? 'bg-green-500 text-white'
                    : step === s.id
                      ? 'bg-[#c78244] text-white'
                      : 'bg-gray-200 text-gray-500'
                }`}
              >
                {step > s.id ? '✓' : s.id}
              </div>
              <span
                className={`mt-1 text-[10px] sm:text-xs text-center truncate w-full px-0.5 ${
                  step === s.id ? 'font-semibold text-[#c78244]' : 'text-gray-500'
                }`}
              >
                {s.label}
              </span>
            </div>
            {idx < labels.length - 1 && (
              <div className={`h-0.5 flex-1 mx-1 ${step > s.id ? 'bg-green-400' : 'bg-gray-200'}`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
